import PropTypes from 'prop-types'
import {Text} from '@chakra-ui/react'

const SubsectionSubTitle = ({description, ...props}) => {
  return (
    <Text
      textStyle="body-detail"
      pb="xs"
      maxW={{base: '100%', md: '80%'}}
      {...props}
    >
      {description}
    </Text>
  )
}

SubsectionSubTitle.propTypes = {
  description: PropTypes.string.isRequired,
}

export default SubsectionSubTitle
